export default {
  loading: "Loading...",
  totalData: "records",
  totalPrefix: "Total",
  download: "Download",
  downloadDetails: "Download Details",
  noData: "No Data",
  columns: {
    direction: "Direction",
    currency: "Crypto",
    quantity: "Quantity",
    price: "Price",
    legalTender: "Fiat",
    amount: "Total Amount",
    txTime: "Transaction Time",
  },
  directions: {
    buy: "Buy",
    sell: "Sell",
    unknown: "Unknown",
  },
};
